// Assign Account Head (DCA) Budget: validation + payload for Accounts/SaveDCAAssignedBudget (spAssignDCABudget, Action 'New').

// spAssignDCABudget declares @Remarks VARCHAR(50): longer text fails with "String or binary data would be truncated".
export const DCA_REMARKS_MAX = 50;

// The SP splits DcaAmounts on ',', so an amount typed as "1,000" would shift every following amount to the wrong
// account head. Only plain positive numbers with up to 2 decimals are accepted.
export const isValidDcaAmount = (v) => /^\d+(\.\d{1,2})?$/.test(String(v ?? '').trim()) && parseFloat(v) > 0;

// rows: [[dcaCode, { amount, checked }]] of the checked account heads.
// ccBalance: the cost centre's BalanceBudget for the selected year (null when the CC has no approved budget for it).
export const validateAssignDCA = ({ ccCode, isPerforming, year, rows, ccBalance, ccBalanceLoading, remarks }) => {
    if (!ccCode) return 'Select a Cost Centre.';
    if (!isPerforming && !year) return 'Select a Year.';
    if (ccBalanceLoading) return 'Cost Centre budget is still loading.';
    if (ccBalance === null || ccBalance === undefined)
        return isPerforming ? 'No approved budget found for this Cost Centre.' : `No approved budget found for this Cost Centre in ${year}.`;
    if (!rows || rows.length === 0) return 'Check at least one Account Head to assign a budget.';
    if (rows.some(([, v]) => !isValidDcaAmount(v.amount)))
        return 'Enter a valid amount (numbers only, no commas, up to 2 decimals) for every checked Account Head.';
    const total = rows.reduce((s, [, v]) => s + parseFloat(v.amount), 0);
    if (total > ccBalance) return 'Account Head budget total is greater than the Cost Centre budget.';
    if (!remarks || !remarks.trim()) return 'Enter Remarks.';
    if (remarks.trim().length > DCA_REMARKS_MAX) return `Remarks can be at most ${DCA_REMARKS_MAX} characters.`;
    return null;
};

// Legacy format: comma-separated lists with a trailing comma (the SP loop needs it).
export const buildAssignDCAPayload = ({ ccCode, isPerforming, year, rows, remarks, currentUser, roleId }) => ({
    DCACode: rows.map(([code]) => code).join(',') + ',',
    DcaAmounts: rows.map(([, v]) => String(v.amount).trim()).join(',') + ',',
    CCCode: ccCode,
    FYyear: isPerforming ? '' : year,
    Remarks: remarks.trim(),
    Action: 'New',
    OldBudgetAmount: 0,
    CreatedBy: currentUser,
    RoleId: roleId,
});
